import { connect } from 'react-redux'
import * as actions from '../services/signin/actions'
import SigninPage from '../components/SigninPage'

function mapStateToProps({ signin }) {
  return { ...signin }
}

export default connect(mapStateToProps, actions)(SigninPage)



// WEBPACK FOOTER //
// ./src/containers/SigninPage.js